import LayoutDefault from "../layout/LayoutDefault";
import HeadersProducts from "../pages/HeadersProducts";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Register from "../pages/Register";
import Logout from "../pages/Logout";
import Products_Details from "../pages/Products_Details";
import User from "../pages/User";
import CreateProducts from "../pages/CreateProducts";
import Cart from "../pages/Cart";
import CheckoutNow from "../pages/CheckoutNow";
import CheckoutCart from "../pages/CheckoutCart";
import ProductsFull from "../pages/ProductsFull";
import WomanProducts from "../pages/WomanProducts";

export const routes = [
  {
    path: "/",
    element: <LayoutDefault />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: `:name/:key`,
        element: <HeadersProducts />,
      },
      {
        path: `products/:id`,
        element: <Products_Details />,
      },
      {
        path: `user/:name`,
        element: <User />,
      },
      {
        path: "products/create",
        element: <CreateProducts />,
      },
      {
        path: "cart",
        element: <Cart />,
      },
      {
        path: "checkoutNow",
        element: <CheckoutNow />,
      },
      {
        path: "checkoutCart",
        element: <CheckoutCart />,
      },
      {
        path: "products",
        element: <ProductsFull />,
      },
      {
        path: "Woman",
        element: <WomanProducts />,
      },
    ],
  },
  {
    path: "login",
    element: <Login />,
  },
  {
    path: "register",
    element: <Register />,
  },
  {
    path: "logout",
    element: <Logout />,
  },
];
